export default __webpack_public_path__ + "static/media/logo.e5214768.jpg";